import { ProgressAction } from "@/apps/StudentExchangeNonPartnerWidget/models/progress-enums"
import { useProgressExchangeBus } from "@/shared/composables/progressExchangeBus"

export function progress(value: string, action: ProgressAction) {
    switch (action) {
        case ProgressAction.ADD:
            if(!useProgressExchangeBus().progress.includes(value)) {
                useProgressExchangeBus().progress.push(value)
            }
            break
        case ProgressAction.REMOVE:
            useProgressExchangeBus().progress = useProgressExchangeBus().progress.filter(item => item != value)
            break
    }
}